//
//  Returns the divisors of a number in descending order
//
export function getDivisors(n: number): number[] {
    const divisors: number[] = [];
    for (let i = n; i >= 1; i--) {
        if (n % i === 0) {
            divisors.push(i);
        }
    }
    return divisors;
}

//
//  Calculate the greatest common denominator between two numbers
//  Used for calculating the aspect ratio for a given resolution
//
export function calculateGCD(a: number, b: number): number {
    const aDivisors = getDivisors(a);
    const bDivisors = getDivisors(b);
    while (aDivisors.length > 0 && bDivisors.length > 0) {
        const aDivisor = aDivisors[0];
        const bDivisor = bDivisors[0];
        if (aDivisor === bDivisor) {
            return aDivisor;
        }
        if (aDivisor > bDivisor) {
            aDivisors.shift();
        }
        else {
            bDivisors.shift();
        }
    }
    return 1;
}

export function calculateAspectRatio(width: number | null, height: number | null) {
    if (!width || !height) {
        return { aspectWidth: 0, aspectHeight: 0 };
    }

    const gcd = calculateGCD(width, height);
    return {
        aspectWidth: width / gcd,
        aspectHeight: height / gcd,
    };
}
